import { BrowserRouter as Router } from 'react-router-dom'

import 'materialize-css/dist/css/materialize.min.css'
import 'materialize-css/dist/js/materialize.min.js'
import './App.scss'

import BackOffice from './Container/BackOffice'
import OktaAuthProvider from './Components/Auth/AuthProvider'
import { AppProvider } from './Context/AppProvider'
import { QueryClient, QueryClientProvider } from 'react-query'

const queryClient = new QueryClient()

function App() {
  return (
    <Router>
      <OktaAuthProvider>
        <QueryClientProvider client={queryClient}>
          <AppProvider>
            <BackOffice />
          </AppProvider>
        </QueryClientProvider>
      </OktaAuthProvider>
    </Router>
  )
}

export default App
